import React from 'react'
import Phase3InboundDashboardPage from 'domains/phase3-inbound-journey/pages/Phase3InboundDashboardPage'
import Phase3CreateIntakePage from 'domains/phase3-inbound-journey/pages/Phase3CreateIntakePage'
import Phase3ProductQueuePage from 'domains/phase3-inbound-journey/pages/Phase3ProductQueuePage'
import Phase3TandaMasukPage from 'domains/phase3-inbound-journey/pages/Phase3TandaMasukPage'
import Phase3InventoryBatchPage from 'domains/phase3-inbound-journey/pages/Phase3InventoryBatchPage'
import Phase3AuditLogPage from 'domains/phase3-inbound-journey/pages/Phase3AuditLogPage'
import Phase3ProductDetailPage from 'domains/phase3-inbound-journey/pages/Phase3ProductDetailPage'
import Phase3PriceTagPrintPage from 'domains/phase3-inbound-journey/pages/Phase3PriceTagPrintPage'
import Phase3InvoicePrintPage from 'domains/phase3-inbound-journey/pages/Phase3InvoicePrintPage'
import Phase3OutboundAuthenticationPage from 'domains/phase3-inbound-journey/pages/Phase3OutboundAuthenticationPage'
import { PHASE3_PRODUCT_SCOPES } from 'domains/phase3-inbound-journey/constants'

const inbound_journey_routes = {
  collapse  : true,
  path      : '/inbound-journey',
  name      : 'Inbound Journey',
  icon      : 'fas fa-project-diagram text-info',
  state_key : 'inbound_journey_collapse',
  invisible : true,
  views     : [
    {
      path      : '/inbound-journey',
      name      : 'Overview',
      miniName  : 'OV',
      component : Phase3InboundDashboardPage,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/create-intake',
      name      : 'Create Consign',
      miniName  : 'CC',
      component : Phase3CreateIntakePage,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/tanda-masuk',
      name      : 'Tanda Masuk',
      miniName  : 'TM',
      component : Phase3TandaMasukPage,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/inventory-batches',
      name      : 'Inventory Batch',
      miniName  : 'IB',
      component : Phase3InventoryBatchPage,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/audit-log',
      name      : 'Audit Log',
      miniName  : 'AL',
      component : Phase3AuditLogPage,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/studio',
      name      : 'Studio Queue',
      miniName  : 'ST',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.STUDIO } title='Studio Check' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/appraisal-needed',
      name      : 'Appraisal Needed',
      miniName  : 'AN',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.APPRAISAL_NEEDED } title='Appraisal Needed' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/confirm-buying-price',
      name      : 'CF Buying Price',
      miniName  : 'CF',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.CONFIRM_BUYING_PRICE } title='Confirm Buying Price' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/appraisal-approval',
      name      : 'Appraisal Approval',
      miniName  : 'AP',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.APPRAISAL_APPROVAL } title='Appraisal Approval' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/appraisal-done',
      name      : 'Appraisal Done',
      miniName  : 'AD',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.APPRAISAL_DONE } title='Appraisal Done' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/price-tag',
      name      : 'Price Tag Queue',
      miniName  : 'PT',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.PRICE_TAG } title='Price Tag + Final Check' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/ready-to-live',
      name      : 'Ready To Live',
      miniName  : 'RL',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.READY_TO_LIVE } title='Ready To Live' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/live',
      name      : 'Live',
      miniName  : 'LV',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.LIVE } title='Live Products' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/deleted',
      name      : 'Deleted',
      miniName  : 'DL',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.DELETED } title='Deleted Products' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/unprocessed',
      name      : 'Unprocessed',
      miniName  : 'UP',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.UNPROCESSED } title='Unprocessed Products' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/incoming',
      name      : 'Incoming',
      miniName  : 'IN',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.INCOMING } title='Incoming Products' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/bkt',
      name      : 'BKT',
      miniName  : 'BKT',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.BKT } title='BKT / Multi Quantity' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/price-tag-print',
      name      : 'Price Tag Print',
      miniName  : 'PR',
      component : Phase3PriceTagPrintPage,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/invoice',
      name      : 'Invoice Print',
      miniName  : 'IV',
      component : Phase3InvoicePrintPage,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/outbound-authentication',
      name      : 'Outbound Auth',
      miniName  : 'OA',
      component : Phase3OutboundAuthenticationPage,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/products/:id',
      name      : 'Product Detail',
      miniName  : 'PD',
      component : Phase3ProductDetailPage,
      layout    : '/app',
      invisible : true
    }
  ]
}

export default inbound_journey_routes
